query getLandingpageBySlug($input: GetLandingpageBySlugInput!) {
  landingpage: getLandingpageBySlug(input: $input) {
    id
    type
    name
    slug
    topicId
    originalUrl
    customUrl
    conversionCount
    status
    materials {
      id
      assetType
      type
      purpose
      mode
      campaignId
      landingpageId
      files {
        file {
          id
          url
          cdnUrl(named: true)
        }
        previewFile {
          id
          url
          cdnUrl
        }
      }
      version
      hasFile
      displayName
      createdAt
      updatedAt
    }
  }
}
